import React from "react";

import { SubscriptionContext } from "../../../../services/SubscriptionService";
import { UpgradeToView } from "../../RowComponents";
/**
 * Render a basic away/hom stat cell
 *
 * @param awayStat The stat for the away team
 * @param homeStat The stat for the home team
 * @param awayBold Whether or not we should bold the away team stat
 * @param homeBold Whether or not we should bold the home team stat
 * @param index The index for the key
 * @param className (optional) if this cell uses a custom className use this
 * @param showStatOverride (optional) set this to true if the stat should never be hidden behind a lock even if the user is anonymous
 */
export const getMoneyCell = (
  game: any,
  awayStat: string,
  homeStat: string,
  drawStat: string,
  awayBold: boolean,
  homeBold: boolean,
  drawBold: boolean,
  index: number,
  sportKey: string,
  showDraw: boolean
) => {
  return (
    <React.Fragment key={index}>
      <SubscriptionContext.Consumer>
        {({ hasSubscriptionAccess }) => {
          const hasAccess = hasSubscriptionAccess(sportKey);
          return game.freeGame || hasAccess ? (
            <div
              key={index}
              className={`games-table-column__money-percent-cell ${
                showDraw ? "games-table-column__money-percent-cell--draw" : ""
              }`}
            >
              <div className="games-table-column__text-container">
                <p className={`games-table-column__line-text ${awayBold ? "games-table-column__line-text--bold" : ""}`}>
                  {awayStat}
                </p>
              </div>
              <div className="games-table-column__text-container">
                <p className={`games-table-column__line-text ${homeBold ? "games-table-column__line-text--bold" : ""}`}>
                  {homeStat}
                </p>
              </div>
              {showDraw ? (
                <div className="games-table-column__text-container">
                  <p
                    className={`games-table-column__line-text ${drawBold ? "games-table-column__line-text--bold" : ""}`}
                  >
                    {drawStat}
                  </p>
                </div>
              ) : null}
            </div>
          ) : (
            <UpgradeToView
              key={index}
              className={`games-table-column__money-percent-cell ${
                showDraw ? "games-table-column__money-percent-cell--draw" : ""
              }`}
              showText={true}
              trackingProps={{
                screen: "FeedView",
                page: "Games Table",
                source: "Money Percent Cell",
                sport: sportKey,
                gameId: game.id,
                awayTeam: game.awayTeam.fullName,
                homeTeam: game.homeTeam.fullName,
              }}
            />
          );
        }}
      </SubscriptionContext.Consumer>
    </React.Fragment>
  );
};
